export const appHead = {"meta":[{"charset":"UTF-8"},{"name":"yandex-verification","content":"f7f11a17cabcb8cb"},{"name":"description","content":"Luxury 5-Star Resort Hotel experince in Salamis Bay Conti Resort Hotel Famagusta, Cyprus"},{"name":"apple-itunes-app","content":"app-id=6477930423"},{"name":"google-play-app","content":"app-id=com.salamisbayconti.hotelapp"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"},{"name":"theme-color","content":"#042333"},{"property":"og:image","content":"https://salamisbayconti.com/og-image.jpg"},{"property":"og:type","content":"website"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:image","content":"https://salamisbayconti.com/og-image.jpg"}],"link":[{"rel":"icon","type":"image/svg+xml","href":"/favicon.svg"},{"rel":"apple-touch-icon","href":"/icon.png"},{"rel":"android-touch-icon","href":"/icon.png"},{"rel":"manifest","href":"/manifest.webmanifest"},{"rel":"alternate","type":"text/plain","href":"/llms.txt"}],"style":[],"script":[{"src":"/js/gtm-consent-default.js","type":"text/javascript","defer":true}],"noscript":[],"title":"Salamis Bay Conti Resort Hotel","htmlAttrs":{"lang":"tr"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false